import { CircularProgress, Grid } from "@material-ui/core";
import React from "react";
import { useStore } from "../../hooks/useStore";
import { useTranslation } from "../../hooks/useTranslation";
import CustomPagination from "./CustomPagination";

const CustomFooterGrid = () => {
  const { registerExitStore } = useStore();
  const { t, BundleKey } = useTranslation();
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item xs={4}>
        {
        registerExitStore.loadingScan ||
        registerExitStore.loadingSearch ||
        registerExitStore.loadingSelecting ? (
          <Grid container alignItems="center">
            <Grid item style={{ marginLeft: 10 }}>
              <CircularProgress size="24px" color="secondary" />
            </Grid>
            <Grid item style={{ marginLeft: 10 }}>{`${t(
              BundleKey.REGISTEREXIT_GRID_LOADING
            )}...`}</Grid>
          </Grid>
        ) : null}
      </Grid>
      <Grid item xs={4}></Grid>
      <Grid item xs={4}>
        <Grid container justifyContent="flex-end">
          <Grid item>
            <CustomPagination />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CustomFooterGrid;
